import Vue from 'vue'
import App from './App.vue'
import router from './router'
import VueMoment from "vue-moment";
import moment from "moment-timezone";
import VueSweetalert2 from "vue-sweetalert2";
import AnimateCSS from 'animate.css';
import Hotjar from 'vue-hotjar';

// Vue.use(VueMoment, {
//   moment
// });

Vue.filter("two_digits", (value) => {
  if (value < 0) {
    return "00";
  }
  if (value.toString().length <= 1) {
    return `0${value}`;
  }
  return value;
});

Vue.config.productionTip = false
import "bootstrap/dist/css/bootstrap.css";
import 'sweetalert2/dist/sweetalert2.min.css';
Vue.use(VueSweetalert2);
Vue.use(AnimateCSS);
Vue.use(require('vue-moment'));
Vue.use (Hotjar, {
  id: '2544023',
  isProduction: true
})

new Vue({
  router,
  render: function (h) { return h(App) }
}).$mount('#app')

